export const CatMasterData = [
    {
      id: "1",
      enable:1,
      code: "MC001",
      name: "Air Conditioner"
    },
    {
      id: "2",
      enable:1,
      code: "MC002",
      name: "Paint"
    },
    {
      id: "3",
      enable:1,
      code: "MC003",
      name: "Wood Work"
    },
  ];